// extracted by mini-css-extract-plugin
module.exports = {"text":"statement_text__2TcNI","inner":"statement_inner__KMhWs","element":"statement_element__2i1hF","link":"statement_link__2bDDZ"};